module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_big.c82430ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_news_big.jpg
// module id = 3035
// module chunks = 11